module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_15.348ec9e6.png";